var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.638,
    height: 36.006,
    opacity: 0.75,
    viewBox: "0 0 37.638 36.006",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_234",
    "data-name": "Group 234",
    transform: "translate(-11.652 -11.214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    "data-name": "Group 207",
    transform: "translate(12.158 11.714)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_206",
    "data-name": "Group 206"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_205",
    "data-name": "Group 205"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M40.73,46.72a.76.76,0,0,1-.166-.018.711.711,0,0,1-.524-.453l-5.372-15.4-5.551,5.306v7.038a.667.667,0,0,1-.21.482L26.052,46.4a.744.744,0,0,1-.632.195.721.721,0,0,1-.535-.373l-4.069-7.782-8.138-3.889a.691.691,0,0,1-.389-.5.662.662,0,0,1,.2-.592l2.857-2.73a.747.747,0,0,1,.516-.2h7.353L28.779,25.2l-16.128-5.14a.7.7,0,0,1-.474-.491.659.659,0,0,1,.191-.64l3.005-2.871a.756.756,0,0,1,.583-.2l20.715,1.8,3.342-3.2c.484-.461,3.017-2.753,5.451-2.753a3.357,3.357,0,0,1,2.371.924c2.032,1.941.5,5.142-1.914,7.454l-3.347,3.2L44.457,43.1a.665.665,0,0,1-.207.543l-3,2.873A.751.751,0,0,1,40.73,46.72ZM34.986,28.88a.76.76,0,0,1,.166.018.711.711,0,0,1,.524.453l5.372,15.4,1.933-1.849L41.1,23.1a.664.664,0,0,1,.207-.543l3.583-3.425c1.331-1.272,3.443-4.065,1.914-5.525a1.868,1.868,0,0,0-1.339-.517c-1.542,0-3.5,1.475-4.419,2.347l-3.582,3.425a.745.745,0,0,1-.583.2l-20.715-1.8-1.947,1.86,16.127,5.139a.7.7,0,0,1,.474.491.659.659,0,0,1-.19.64l-6.594,6.305a.748.748,0,0,1-.516.2H16.164l-1.943,1.857,7.465,3.567a.706.706,0,0,1,.323.309l3.725,7.125,1.932-1.846V35.87a.666.666,0,0,1,.21-.482l6.594-6.3A.746.746,0,0,1,34.986,28.88Z",
    transform: "translate(-12.158 -11.714)",
    fill: "#1c474a",
    stroke: "#1c474a",
    strokeWidth: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.04c67082f8d1f7c94b63a60e73cc741d.svg";
export { ForwardRef as ReactComponent };